(() => {
  const normalize = (value = '') => value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9\s-]/g, ' ');
  const words = value => [...new Set(normalize(value).split(/\s+/).filter(w => w.length > 2))];
  const escapeHtml = value => String(value || '').replace(/[&<>'"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));

  document.querySelectorAll('[data-hl-quiz]').forEach(root => {
    const app = root.querySelector('[data-quiz-app]');
    if (!app) return;
    const questions = [...root.querySelectorAll('[data-question]')];
    const freeform = root.querySelector('[data-freeform]');
    const resultPanel = root.querySelector('[data-quiz-results-panel]');
    const resultGrid = root.querySelector('[data-result-grid]');
    const progress = root.querySelector('[data-quiz-progress]');
    const stepLabel = root.querySelector('[data-step-label]');
    const freeText = root.querySelector('[data-free-text]');
    const products = [...root.querySelectorAll('[data-quiz-product]')].map(el => ({
      id: el.dataset.id,
      title: el.dataset.title,
      url: el.dataset.url,
      image: el.dataset.image,
      price: el.dataset.price,
      search: normalize(el.dataset.search),
      profile: normalize(el.dataset.profile),
      family: el.querySelector('[data-family]')?.textContent.trim() || '',
      notes: el.querySelector('[data-notes]')?.textContent.trim() || ''
    }));
    const answers = {};
    let index = 0;

    const showQuestion = next => {
      index = Math.max(0, Math.min(next, questions.length - 1));
      questions.forEach((q, i) => q.classList.toggle('is-active', i === index));
      freeform.hidden = true;
      resultPanel.hidden = true;
      stepLabel.hidden = false;
      stepLabel.textContent = `Question ${index + 1} of ${questions.length}`;
      progress.style.width = `${((index + 1) / (questions.length + 1)) * 100}%`;
      questions[index]?.querySelector('button')?.focus({preventScroll:true});
    };

    questions.forEach((q, qIndex) => q.querySelectorAll('button[data-value]').forEach(button => {
      button.addEventListener('click', () => {
        q.querySelectorAll('button').forEach(b => b.classList.remove('is-selected'));
        button.classList.add('is-selected');
        answers[q.dataset.question] = button.dataset.value;
        if (qIndex < questions.length - 1) {
          showQuestion(qIndex + 1);
        } else {
          questions.forEach(el => el.classList.remove('is-active'));
          freeform.hidden = false;
          stepLabel.textContent = 'Final touch';
          progress.style.width = '100%';
          freeText?.focus({preventScroll:true});
        }
      });
    }));

    const scoreProducts = () => {
      const answerWords = words(Object.values(answers).join(' '));
      const queryWords = words(freeText?.value || '');
      return products.map(product => {
        let score = 0;
        const matched = [];
        answerWords.forEach(word => {
          if (product.search.includes(word)) { score += 3; matched.push(word); }
          if (product.profile.includes(word)) { score += 6; matched.push(word); }
        });
        queryWords.forEach(word => {
          if (product.search.includes(word)) { score += 4; matched.push(word); }
          if (product.profile.includes(word)) { score += 8; matched.push(word); }
        });
        // Give every fragrance a deterministic baseline so incomplete product data still yields stable results.
        const stable = [...String(product.id)].reduce((sum, ch) => sum + ch.charCodeAt(0), 0) % 7;
        score += stable / 10;
        return {...product, score, matched:[...new Set(matched)].slice(0,5)};
      }).sort((a,b) => b.score - a.score || a.title.localeCompare(b.title));
    };

    const reason = item => {
      const family = item.family ? `${escapeHtml(item.family)} profile` : 'fragrance profile';
      if (item.matched.length) {
        const terms = item.matched.slice(0,3).join(', ');
        return `A strong match for the ${escapeHtml(terms)} cues in your answers, with a ${family} that keeps the recommendation grounded in the fragrance itself.`;
      }
      return `Chosen as one of the closest overall matches from the Hickory Lane library. Add fragrance metafields or quiz-profile tags to make this recommendation even more precise.`;
    };

    const renderResults = () => {
      const ranked = scoreProducts().slice(0,3);
      resultGrid.innerHTML = ranked.map((item, i) => `
        <article class="hl-quiz-result">
          <a class="hl-quiz-result__image" href="${escapeHtml(item.url)}" aria-label="Discover ${escapeHtml(item.title)}">
            ${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy" width="720" height="900">` : ''}
          </a>
          <div class="hl-quiz-result__body">
            <div class="hl-quiz-result__rank">${i === 0 ? 'Best match' : `Match ${i + 1}`}</div>
            <h4>${escapeHtml(item.title)}</h4>
            <p class="hl-quiz-result__why">${reason(item)}</p>
            <div class="hl-quiz-result__meta"><span>${escapeHtml(item.price)}</span><a href="${escapeHtml(item.url)}">Discover scent</a></div>
          </div>
        </article>`).join('');
      questions.forEach(el => el.classList.remove('is-active'));
      freeform.hidden = true;
      resultPanel.hidden = false;
      stepLabel.hidden = true;
      progress.style.width = '100%';
      resultPanel.querySelector('h3')?.focus?.({preventScroll:true});
      root.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start'});
    };

    root.querySelector('[data-quiz-results]')?.addEventListener('click', renderResults);
    root.querySelector('[data-quiz-back]')?.addEventListener('click', () => showQuestion(questions.length - 1));
    root.querySelector('[data-quiz-restart]')?.addEventListener('click', () => {
      Object.keys(answers).forEach(k => delete answers[k]);
      root.querySelectorAll('.is-selected').forEach(el => el.classList.remove('is-selected'));
      if (freeText) freeText.value = '';
      resultGrid.innerHTML = '';
      showQuestion(0);
      root.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start'});
    });
    showQuestion(0);
  });
})();
